import { api } from './http';

export type Category = {
  id: number;
  name: string;
  sort: number;
  article_count: number;
  published_count: number;
};

export const categories = {
  list: (signal?: AbortSignal) => api.get<{ categories: Category[] }>('/categories', signal),
  create: (name: string) => api.post<{ category: Category }>('/categories', { name }),
  /** Renaming rewrites every article in it; `moved` says how many. */
  rename: (id: number, name: string) =>
    api.put<{ category: Category & { moved: number } }>(`/categories/${id}`, { name }),
  /** Without `moveTo`, a category with articles in it is refused, not emptied. */
  remove: (id: number, moveTo = '') =>
    api.del<{ ok: true; moved: number; to: string }>(
      `/categories/${id}${moveTo ? `?move_to=${encodeURIComponent(moveTo)}` : ''}`),
  reorder: (ids: number[]) => api.post<{ categories: Category[] }>('/categories/order', { ids }),
};
